<template>
  <v-container>
  <v-layout v-if="error">
    <v-flex xs12 sm6 offset-sm3>
    <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
    </v-flex>
  </v-layout>
  <v-layout>
    <v-flex xs12 sm6 offset-sm3>
      
      <v-card-text>
        <h3>You only need to sign in if you are going to upload content.</h3>
        <v-container>
        </v-container>
        <form @submit.prevent="onSignin">
          <v-layout row>
            <v-flex xs12>
              <v-text-field
              name = "email"
              label = "Mail"
              id = "email"
              v-model = "email"
              type = "email"
              required
            >
              </v-text-field>
             
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12>
              <v-text-field
              name = "password"
              label = "Password"
              id = "password"
              v-model = "password"
              type = "password"
              required >
              </v-text-field>
              <div class="forgot" v-if="showForgot" @click="doForgot">Reset Password</div> 
            </v-flex>
          </v-layout>
          
           <v-layout row>
            <v-flex xs12>
            <v-btn type="submit" :disabled="loading" :loading="loading">Sign In
              <span slot="loader" class="customLoader">
              <v-icon light>cached</v-icon>
              </span>
              </v-btn>
              <v-btn  :disabled="loading" :loading="loading" @click="onSigninGoogle">Sign In With Google
              <span slot="loader" class="customLoader">
              <v-icon light>cached</v-icon>
              </span>
              </v-btn>
              </v-text-field>

            </v-flex>
          </v-layout>
        </form>
      </v-card-text>
    </v-flex>
  </v-layout>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      email: '',
      password: '',
      confirmPassword: '',
      showForgot:false
    }
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  watch: {
    user (value) {
      if (value !== null && value !== undefined) {
        //this.$router.push('/participate')
       
        console.log("USER CHANGED")
        this.$router.go(-1)
      }
    },
    error(val){
      if (val){
        this.showForgot=true;
      }
    }
  },
  methods: {
    doForgot(){
      console.log("FORGOT",this.email)
       this.$store.dispatch('forgotPassword', this.email)
    },
    onSignin () {
      console.log('email:', this.email)
      this.$store.dispatch('signUserIn', {email: this.email, password: this.password})
    },
    onSigninGoogle () {
      
      this.$store.dispatch('signUserUpGoogle', {email: 'this.email', password: 'this.password'})
    },
    onDismissed () {
      console.log('Dismissed alert')
      this.$store.dispatch('clearError')
    }
  }
}
</script>
<style>
  .forgot{
    z-index: 1;
    color: #ff5252;
    margin-top: -10px;
    margin-bottom: 20px;
    cursor: pointer;

  }
</style>


// WEBPACK FOOTER //
// src/components/User/Signin.vue